import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_safeLinkSchemes() {
  _init_properties_UrlSafety_kt__cgknfz();
  return safeLinkSchemes;
}
var safeLinkSchemes;
function safeLinkUrlOrNull(url) {
  _init_properties_UrlSafety_kt__cgknfz();
  var tmp;
  if (url == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (isSafeLinkUrl(url)) {
      tmp_0 = url;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function isSafeLinkUrl(url) {
  _init_properties_UrlSafety_kt__cgknfz();
  // Inline function 'kotlin.text.filter' call
  // Inline function 'kotlin.text.filterTo' call
  var destination = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  var inductionVariable = 0;
  var last = charSequenceLength(url);
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var element = charSequenceGet(url, index);
      var tmp;
      // Inline function 'kotlin.code' call
      if (Char__toInt_impl_vasixd(element) > 32) {
        // Inline function 'kotlin.code' call
        tmp = !(Char__toInt_impl_vasixd(element) === 127);
      } else {
        tmp = false;
      }
      if (tmp) {
        destination.append_58al37_k$(element);
      }
    }
     while (inductionVariable < last);
  var cleaned = destination.toString();
  var colon = indexOf(cleaned, _Char___init__impl__6a9atx(58));
  if (colon < 0)
    return true;
  var tmp$ret$5;
  $l$block: {
    // Inline function 'kotlin.text.indexOfFirst' call
    var inductionVariable_0 = 0;
    var last_0 = charSequenceLength(cleaned) - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var it = charSequenceGet(cleaned, index_0);
        if (it === _Char___init__impl__6a9atx(47) || it === _Char___init__impl__6a9atx(63) || it === _Char___init__impl__6a9atx(35)) {
          tmp$ret$5 = index_0;
          break $l$block;
        }
      }
       while (inductionVariable_0 <= last_0);
    tmp$ret$5 = -1;
  }
  var delimiter = tmp$ret$5;
  if (0 <= delimiter ? delimiter < colon : false)
    return true;
  var tmp_0 = get_safeLinkSchemes();
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$7 = substring(cleaned, 0, colon).toLowerCase();
  return tmp_0.contains_aljjnj_k$(tmp$ret$7);
}
var properties_initialized_UrlSafety_kt_v9q7ox;
function _init_properties_UrlSafety_kt__cgknfz() {
  if (!properties_initialized_UrlSafety_kt_v9q7ox) {
    properties_initialized_UrlSafety_kt_v9q7ox = true;
    safeLinkSchemes = setOf(['http', 'https', 'mailto', 'tel', 'sms']);
  }
}
//region block: exports
export {
  safeLinkUrlOrNull as safeLinkUrlOrNulle8yc4vtqk4ie,
};
//endregion

//# sourceMappingURL=UrlSafety.mjs.map
